module.exports = __webpack_public_path__ + "img/doc_icon.3de76694.svg";